<template>
  <div class="productQuotationApplicationAdd container">
    <div class="searchBox">
      <div>
        <el-button size="mini" class="btn" v-if="saveSubmitBtnShow" type="primary" v-acl="ProductQuoteSave" @click="updateQuotation('save')">保存</el-button>
        <!--保存-->
        <el-button size="mini" class="btn" v-if="saveSubmitBtnShow" type="primary" v-acl="ProductQuoteSave" @click="updateQuotation('submit')">提交</el-button>
        <!--提交-->
        <el-button size="mini" class="btn" type="primary" @click="historyBack">关闭</el-button>
      </div>
      <el-form label-width="120px" ref="headDataForm" :model="headData" label-position="right" class="topform">
        <el-row :gutter="20">
          <el-col :xs="1" :md="12" :lg="8" :xl="6">
            <el-form-item label="单据编号" class="handle-input">
              <el-input class="handle-input" v-model="headData.applyNo" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="1" :md="12" :lg="8" :xl="6">
            <el-form-item label="主题">
              <el-input class="handle-input" v-model="headData.subject" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="1" :md="12" :lg="8" :xl="6">
            <el-form-item label="创建人">
              <el-input class="handle-input" v-model="headData.name" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="1" :md="12" :lg="8" :xl="6">
            <el-form-item label="创建日期">
              <el-date-picker style="width:100%" value-format="yyyy-MM-dd" type="date" v-model="headData.createDate" placeholder="选择日期" disabled></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="产品报价明细" name="first">
        <el-row style="margin-bottom:10px" type="flex" justify="start" align="middle">
          <el-button size="mini" class="btn" type="primary" @click="exportDetail">{{$t("common.export")}}</el-button>
          <el-upload class="apply-import-button" v-if="saveSubmitBtnShow" :on-error="importDetailError" :on-success="importDetailSuccess" :before-upload="beforeUpload" :show-file-list="false" :action="importDetailUrl" :multiple="false" :headers="headers">
            <el-button size="mini" type="primary">{{$t('common.import')}}</el-button>
          </el-upload>
        </el-row>
        <ux-grid ref="quotationLineTableDataRef" :data="quotationLineTableData" keep-source max-height="550" @sort-change="changeSort" show-overflow="tooltip">
          <!-- <ux-table-column align="center" type="checkbox" width="80" /> -->
          <ux-table-column align="center" title="操作" min-width="80" v-show="saveSubmitBtnShow">
            <template v-slot="scope">
              <i class="el-icon-edit-outline" @click="onEdit(scope)"></i>
            </template>
          </ux-table-column>
          <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="供应商" field="supplierName" min-width="160px" fixed></ux-table-column>
          <ux-table-column align="center" sortable resizable title="8位码" field="eightBitCode" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="8位码名称" field="eightBitCodeName" min-width="160px"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="提货点" field="pickupPoint" min-width="120"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="到货仓库" field="dcName" min-width="160px"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="温区" field="temperatureI18n" min-width="80px"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="有效开始日期" field="effectiveBeginDate" min-width="160"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="非标准线路运费" field="isSpecialFreight" min-width="160px">
            <template v-slot="scope">
              {{scope.row.isSpecialFreight |setIsSpecialFreight}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" sortable resizable title="运输方式" field="transportaionMethod" min-width="120px">
            <template v-slot="scope">
              {{scope.row.transportaionMethod | ic("COMMON",'TRANSPORTAION_METHOD')}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" sortable resizable title="线路结算单位" field="lineUnit" min-width="140">
            <template v-slot="scope">
              {{scope.row.lineUnit | ic("COMMON",'UNIT')}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" sortable resizable title="线路价格" field="linePrice" min-width="120px"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="产品运费（不含税）" field="productPrice" min-width="170px"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="现有产品价格" field="currentProductPrice" min-width="140"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="价格变化" field="changeRate" min-width="120px"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="LeadTime" field="leadTime" min-width="120px"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="外包装长(cm)" field="externalPackagingLength" min-width="140"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="外包装宽(cm)" field="externalPackagingWidth" min-width="140"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="外包装高(cm)" field="externalPackagingHeight" min-width="140"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="外包装净重(kg)" field="externalPackagingNetweight" min-width="160"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="外包装毛重(kg)" field="externalPackagingGrossweight" min-width="160"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="每Pallet层数" field="palletLayerNumber" min-width="160"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="每层箱数" field="palletLayerBoxNumber" min-width="120"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="托盘上物品长度(cm)" field="palletItemsLength" min-width="180"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="托盘上物品宽度(cm)" field="palletItemsWidth" min-width="180"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="托盘上物品高度(cm)" field="palletItemsHeight" min-width="180"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="备注" field="remarks" min-width="180"></ux-table-column>
        </ux-grid>
      </el-tab-pane>
      <el-tab-pane label="附件" name="second">
        <el-upload v-show="showUploadFlag" style="float:left" ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        </el-upload>
        <el-table :data="fileList" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
            <template slot-scope="scope">
              <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}}</el-link>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
            <template slot-scope="scope">
              {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip v-if="showUploadFlag" prop="tmDocumentId" min-width="130px">
            <template slot-scope="scope">
              <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,fileList)">{{$t('common.del')}}</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="报价明细" :visible.sync="dialogEditVisible" width="80%" @close="onCancel">
      <el-table :data="tableData" ref="tableDataRef" border highlight-current-row max-height="470">
        <el-table-column show-overflow-tooltip sortable="custom" prop="supplierName" min-width="160px" label="供应商" fixed></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="eightBitCode" width="140" label="8位码" fixed></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="eightBitCodeName" min-width="160px" label="8位码名称"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="pickupPoint" min-width="160px" label="提货点"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="dcName" min-width="160px" label="到货仓库"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="temperatureI18n" min-width="80px" label="温区"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="effectiveBeginDate" min-width="200px" label="有效开始日期">
          <template slot-scope="scope">
            <el-date-picker :picker-options="(headData.applyType==4)?pickerOptions:''" style="width: 100%" value-format="yyyy-MM-dd" v-model="scope.row.effectiveBeginDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="isSpecialFreight" label="非标准线路运费" min-width="160px">
          <template slot-scope="scope">
            <ic-select :options="{Y:'是' , N:'否'}" @change="calcQuotationProductPrice(scope.row,scope.$index,'N')" v-model="scope.row.isSpecialFreight"></ic-select>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="transportaionMethod" label="运输方式" min-width="120px">
          <template slot-scope="scope">
            <ic-select @change="calcQuotationProductPrice(scope.row,scope.$index,'N')" table="COMMON" field="TRANSPORTAION_METHOD" v-model="scope.row.transportaionMethod"></ic-select>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="lineUnit" label="线路结算单位" min-width="120px">
          <template slot-scope="scope" v-if="scope.row.isSpecialFreight=='N'">
            <el-select @change="calcQuotationProductPrice(scope.row,scope.$index,'N')" :disabled="scope.row.lineDisabled" v-model="scope.row.lineUnit" class="handle-input">
              <el-option :key="index" v-for="(item,index) in unitList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="linePrice" label="线路价格" min-width="100px">
          <template slot-scope="scope" v-if="scope.row.isSpecialFreight=='N'">
            <el-input @blur="calcQuotationProductPrice(scope.row,scope.$index,'Y')" v-model="scope.row.linePrice" :disabled="scope.row.lineDisabled"></el-input>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="productPrice" label="产品运费（不含税）" min-width="170px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.productPrice" @blur="setPrice(scope.row.productPrice,scope.$index)" :disabled="productPriceDisabledM(scope.row) "></el-input>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="currentProductPrice" label="现有产品价格" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="changeRate" label="价格变化" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="leadTime" label="LeadTime" width="160px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.leadTime"></el-input>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="externalPackagingLength" label="外包装长(cm)" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="externalPackagingWidth" label="外包装宽(cm)" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="externalPackagingHeight" label="外包装高(cm)" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="externalPackagingNetweight" label="外包装净重(kg)" min-width="130px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="externalPackagingGrossweight" label="外包装毛重(kg)" min-width="130px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="palletLayerNumber" label="每Pallet层数" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="palletLayerBoxNumber" label="每层箱数" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="palletItemsLength" label="托盘上物品长度(cm)" min-width="170px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="palletItemsWidth" label="托盘上物品宽度(cm)" min-width="170px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable="custom" prop="palletItemsHeight" label="托盘上物品高度(cm)" min-width="170px"></el-table-column>
        <el-table-column show-overflow-tooltip prop="remarks" label="备注" width="220px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remarks" :disabled="remarkDisabledM(scope.row)"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="center" style="margin-top:10px;">
        <el-button type="primary" @click="onConfirm">确认</el-button>
        <el-button type="primary" @click="onCancel">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import {
  quotationInit,
  updateQuotationPro,
  calcProductPrice
} from "@/api/quoteByProductSup.js";
import { inputChoiceService } from "@/api/common/input-choice";
import { fileService } from "@/api/common/file-utils";
import commonConstants from "../../../../constants/commonConstants";
import commonFun from "@/utils/commonFun";
import { Message } from "element-ui";
import IcSelect from "@/components/common/icSelect";
import { quotationService } from "@/api/quotation-apply-sup/quotation-service";

export default {
  components: { IcSelect },
  computed: {
    importDetailUrl() {
      return commonConstants.baseUrl + `productQuote/importDetail/${this.ttQuotationId}`;
    },
    headers() {
      return {
        "x-access-token": localStorage.getItem('token')
      }
    }
  },
  data() {
    let minDate = new Date();
    if (minDate.getMonth() >= 10) {
      minDate.setFullYear(minDate.getFullYear() + 1);
      minDate.setMonth(minDate.getMonth() + 1 - 12);
    } else {
      minDate.setMonth(minDate.getMonth() + 1);
    }
    minDate.setDate(1);
    return {
      loadingInstance: null,
      pickerOptions: {
        defaultValue: minDate,
        disabledDate: (date) => {
          let now = new Date();
          if (now.getMonth() >= 10) {
            now.setFullYear(now.getFullYear() + 1);
            now.setMonth(now.getMonth() + 1 - 12);
          } else {
            now.setMonth(now.getMonth() + 1);
          }
          now.setDate(0);
          return date.getTime() >= now.getTime() ? false : true;
        }
      },
      saveSubmitBtnShow: false,
      currencyList: [],
      quotationLineTableData: [],
      isSpecialFreight: false,
      ttQuotationId: '',
      showUploadFlag: false,
      activeName: 'first',
      headData: {},
      quotation: {},
      transportaionMethodList: [],
      fileList: [],
      unitList: [],
      tmSupplierId: '',
      saveSubmit: '',
      isShowMsg: false,
      dialogEditVisible: false,
      tableData: [],
      index: null,
      isShow: true,
      isShow1: true,
    };
  },
  created() {
    this.$nextTick(() => {
      this.ttQuotationApplyRoundId = this.$route.query.roundId;
      this.quotationPageInitM(this.$route.query.roundId);
      this.getInputChoiceValues();
      setTimeout(() => {
        if (this.saveSubmitBtnShow) {
          this.updateQuotation('save')
        }
      }, 1000)

    })
  },
  watch: {},
  filters: {
    setIsSpecialFreight(key) {
      if (key == 'Y') {
        return '是'
      } else if (key == 'N') {
        return '否'
      } else {
        return key
      }
    },
  },
  methods: {
    quotationPageInitM(param) {
      let _this = this;
      quotationInit(param).then((res) => {
        _this.ttQuotationId = res.ttQuotationId;
        _this.headData = res.quotationApply;
        _this.quotation = res.quotation;
        _this.tmSupplierId = res.tmSupplierId;
        _this.getFiles(res.tmSupplierId);
        //不是报价中的报价单不可以编辑(并且只能修改报价为供应商商报价)
        let quotationType = res.quotationApply.quotationType;
        if ('1' == res.status && quotationType == 'SUP') {
          _this.saveSubmitBtnShow = true;
        }
        if (null != res.ttQuotationId && '1' == res.status && quotationType == 'SUP') {
          _this.showUploadFlag = true;
        }

        //设置线路计量单位与线路价格是否可以编辑
        if (res.quotationProductList.length > 0) {
          res.quotationProductList.forEach(item => {
            item.lineDisabled = false;
            if (!_this.saveSubmitBtnShow) {
              item.lineDisabled = true;
            } else if (item.isSpecialFreight == 'N' && !!item.tmLineId) {
              item.lineDisabled = true;
            }
          })
        }
        if (res.quotationProductList.length > 0) {
          _this.quotationLineTableData = res.quotationProductList;
        } else {
          _this.quotationLineTableData = []
        }
        this.$refs.quotationLineTableDataRef.reloadData(res.quotationProductList)
      });
    },
    onEdit(scope) {
      this.dialogEditVisible = true
      this.index = scope.rowIndex
      this.tableData.push(JSON.parse(JSON.stringify(scope.row)))
    },
    setPrice(price, index) {
      console.log('price', price);
      if (price.indexOf('-') != -1) {
        price = price.replace(/-/g, '')
      }
      var val = parseFloat(price)
      if (isNaN(val)) {
        return false
      }
      console.log('val', val);
      val = Math.round(val * 1000000) / 1000000
      this.tableData[index].productPrice = val
    },
    onConfirm() {
      this.$refs.quotationLineTableDataRef.reloadRow(this.$refs.quotationLineTableDataRef.data[this.index], this.tableData[0], null)
      this.dialogEditVisible = false
      setTimeout(() => {
        this.tableData = []
      }, 500);
    },
    onCancel() {
      this.dialogEditVisible = false
      this.tableData = []
    },
    exportDetail() {
      if (!this.ttQuotationId) {
        this.$message({ message: "请先保存数据再对数据进行导出导入修改！", type: "error" });
        return;
      }
      quotationService.exportPxDetail(this.ttQuotationId).then(resp => {
        fileService.respToFile(resp, "产品报价确认报表-" + this.headData.applyNo + ".xlsx");
      })
    },
    // 保存/提交
    updateQuotation(method) {
      let _this = this;
      _this.saveSubmit = method;
      let quotationInfo = {};
      quotationInfo.method = method;
      quotationInfo.quotation = this.quotation;
      quotationInfo.quotationProductList = this.quotationLineTableData;
      // let validFlag = false;
      // _this.$refs['formTable'].validate((valid) => {
      //   validFlag = valid;
      // });
      // if (!validFlag) {
      //   return;
      // }
      if ('submit' == method) {
        for (let i = 0; i < quotationInfo.quotationProductList.length; i++) {
          let item = quotationInfo.quotationProductList[i];
          if (_this.headData.applyType == 4 && _this.pickerOptions.disabledDate(new Date(item.effectiveBeginDate))) {
            _this.$message({ message: '第' + (i + 1) + '行' + _this.$t("apply.pleaseSelectNextNextMonthDate"), type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.effectiveBeginDate)) {
            _this.$message({ message: '第' + (i + 1) + '行' + "有效开始日期不能为空", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.isSpecialFreight)) {
            _this.$message({ message: '第' + (i + 1) + '行' + "非标准线路运费不能为空", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.transportaionMethod)) {
            _this.$message({ message: '第' + (i + 1) + '行' + "运输方式不能为空", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.leadTime)) {
            _this.$message({ message: '第' + (i + 1) + '行' + "LeadTime不能为空", type: "warning" });
            return;
          }
          if (item.isSpecialFreight === 'Y') {
            if (commonFun.isEmpty(item.productPrice)) {
              _this.$message({ message: '第' + (i + 1) + '行' + "产品运费（不含税）不能为空", type: "warning" });
              return;
            }
            if (commonFun.isNotEmpty(item.productPrice)) {
              if (isNaN(((item.productPrice + "").trim()) * 1)) {
                _this.$message({ message: '第' + (i + 1) + '行' + "请正确输入产品运费（不含税）!", type: "warning" });
                return;
              }
            }
          }
          if (item.isSpecialFreight === 'N') {
            if (commonFun.isEmpty(item.lineUnit)) {
              _this.$message({ message: '第' + (i + 1) + '行' + "结算单位不能为空", type: "warning" });
              return;
            }
            if (commonFun.isEmpty(item.linePrice)) {
              _this.$message({ message: '第' + (i + 1) + '行' + "线路价格不能为空", type: "warning" });
              return;
            }
            if (commonFun.isNotEmpty(item.linePrice)) {
              if (isNaN(((item.linePrice + "").trim()) * 1)) {
                _this.$message({ message: '第' + (i + 1) + '行' + "请正确输入线路价格!", type: "warning" });
                return;
              }
            }
          }
        }
        _this.$confirm(this.$t("apply.sureSubmit"), this.$t("common.tips"), {
          confirmButtonText: this.$t("common.confirm"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            _this.$message({ message: _this.$t('common.submitSuccess'), type: "success" });
            updateQuotationPro(quotationInfo).then((res) => {
              if (res.meta.code === 200) {
                _this.$message({ message: _this.$t('common.submitSuccess'), type: "success" });
                _this.historyBack();
              }
            });
          })
          .catch(() => {
          });
      } else {
        updateQuotationPro(quotationInfo).then((res) => {
          if (this.isShowMsg) {
            _this.$message({ message: _this.$t('common.saveSuccess'), type: "success" });
          }
          _this.quotationPageInitM(_this.ttQuotationApplyRoundId)
          this.isShowMsg = true
        });
      }

    },
    historyBack: function () {
      this.$router.go(-1);
    },
    beforeUpload(file) {
      if (!this.ttQuotationId) {
        this.$message({ message: "请先保存数据再对数据进行导出导入修改！", type: "error" });
        return false;
      }
      this.loadingInstance = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    importDetailSuccess(resp, file) {
      if (resp.meta.code === 200) {
        this.$message.success('导入完成，完成报价数据' + resp.data + '条')
        this.quotationPageInitM(this.ttQuotationApplyRoundId);
        // this.quotationPageInitM(this.$route.query.roundId);
      } else {
        this.$message.error(res.meta.msg)
      }
      this.loadingInstance.close();
    },
    importDetailError(resp) {
      this.loadingInstance.close();
      Message.error(JSON.parse(resp.message).msg);
    },
    //文件上传
    uploadConfirm(item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = _this.tmSupplierId + '';
        attachment.tsRecId = _this.ttQuotationId;
        attachment.tsReckindId = 'QUOTATION';
        console.log(attachment)
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles(_this.tmSupplierId);
        })
      }).catch((error) => {
        Message({ message: "文件上传失败", type: "error" });
      });
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    //文件下载
    downloadFile(row) {
      fileService.downloadFile(row).then((res) => {
      })
    },
    //文件列表数据获取
    getFiles(tmSupplierId) {
      let attachment = {};
      attachment.seq = tmSupplierId + '';
      attachment.tsRecId = this.ttQuotationId;
      attachment.tsReckindId = 'QUOTATION';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      mapObj["COMMON:TRANSPORTAION_METHOD"] = "COMMON:TRANSPORTAION_METHOD";
      mapObj["COMMON:UNIT"] = "COMMON:UNIT";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
        this.transportaionMethodList = res["COMMON:TRANSPORTAION_METHOD"];
        this.unitList = res["COMMON:UNIT"];
      });
      inputChoiceService.getCurrencyList().then((res) => {
        this.currencyList = res;
      });
    },
    productPriceDisabledM(row) {
      let _this = this;
      if (!_this.saveSubmitBtnShow) {
        return true;
      }
      if (row.isSpecialFreight == 'Y') {
        row.linePrice = '';
        row.lineUnit = '';
        return false;
      } else {
        if (row.lineUnit == null || row.lineUnit == '') {
          row.productPrice = '';
        }
        return true;
      }
    },
    remarkDisabledM(row) {
      let _this = this;
      if (!_this.saveSubmitBtnShow) {
        return true;
      }
    },
    // importDetailSuccess(resp) {
    //   Message.success("导入完成，完成报价数据" + resp.data + "条");
    //   this.quotationPageInitM(this.$route.query.roundId);
    // },
    calcQuotationProductPrice(row, index, val) {
      if (val === 'Y') {
        if (row.linePrice.indexOf('-') != -1) {
          row.linePrice = row.linePrice.replace(/-/g, '')
        }
        var val = parseFloat(row.linePrice)
        if (isNaN(val)) {
          return false
        }
        val = Math.round(val * 1000000) / 1000000
        this.tableData[index].linePrice = val
      }
      let isSpecialFreight = row.isSpecialFreight;
      let transportaionMethod = row.transportaionMethod;
      let productDto = {
        'linePrice': row.linePrice,
        'lineUnit': row.lineUnit,
        'isSpecialFreight': row.isSpecialFreight,
        'transportaionMethod': row.transportaionMethod,
        'temperature': row.temperature,
        'tmPickupId': row.tmPickupId,
        'tmDcId': row.tmDcId,
        'palletLayerNumber': row.palletLayerNumber,
        'palletLayerBoxNumber': row.palletLayerBoxNumber,
        'externalPackagingGrossweight': row.externalPackagingGrossweight,
        'externalPackagingLength': row.externalPackagingLength,
        'externalPackagingWidth': row.externalPackagingWidth,
        'externalPackagingHeight': row.externalPackagingHeight
      };
      // if (isSpecialFreight == 'N') {
      //   this.$refs.formTable.clearValidate('quotationLineTableData.' + index + '.productPrice');
      // }
      if (isSpecialFreight == 'N' && (commonFun.isNotEmpty(transportaionMethod))) {
        //选择了不是特殊运费,并且选择了运输方式,调用后台进行计算
        calcProductPrice(productDto).then((res) => {
          row.productPrice = res.productPrice;
          row.linePrice = res.linePrice;
          row.lineUnit = res.lineUnit;
          row.tmLineId = res.tmLineId;
          if (commonFun.isNotEmpty(res.leadTime)) {
            row.leadTime = res.leadTime;
          }
          //如果匹配到线路则线路结算单位与线路金额不能修改
          if (!!row.tmLineId) {
            row.lineDisabled = true;
          } else {
            row.lineDisabled = false;
          }
        });
      }
    },
    changeSort(column) {
      //清除校验
      let $ref = this.$refs['formTable'];
      this.$nextTick(() => {
        $ref.clearValidate();
      })
      //获取字段名称和排序类型
      let fieldName = column.prop;
      let sortingType = column.order;
      //如果字段名称为“effectiveBeginDate”，将“创建时间”转换为时间戳，才能进行大小比较
      if (fieldName == "effectiveBeginDate") {
        this.quotationLineTableData.map(item => {
          item.effectiveBeginDate = new Date(item.effectiveBeginDate).getTime()
        });
      }
      if (fieldName == "externalPackagingHeight" || fieldName == "externalPackagingNetweight" || fieldName == "externalPackagingGrossweight" || fieldName == "palletLayerNumber" || fieldName == "palletLayerBoxNumber" || fieldName == "effectiveBeginDate" || fieldName == "eightBitCode" || fieldName == "linePrice" || fieldName == "leadTime" || fieldName == "estimatedAnnualFee" || fieldName == "productPrice" || fieldName == "externalPackagingLength" || fieldName == "externalPackagingWidth") {
        //数字按照降序排序
        if (sortingType == "descending") {
          this.quotationLineTableData = this.quotationLineTableData.sort((a, b) => b[fieldName] - a[fieldName]);
        } else {
          //按照升序排序
          this.quotationLineTableData = this.quotationLineTableData.sort((a, b) => a[fieldName] - b[fieldName]);
        }
      } else {
        //字符串按照降序排序
        if (sortingType == "descending") {
          this.quotationLineTableData = this.quotationLineTableData.sort((a, b) => a[fieldName] == null ? -1 : a[fieldName].localeCompare(b[fieldName] == null ? -1 : b[fieldName]));

        } else {
          //按照升序排序
          this.quotationLineTableData = this.quotationLineTableData.sort((a, b) => b[fieldName] == null ? -1 : b[fieldName].localeCompare(a[fieldName] == null ? -1 : a[fieldName]));
        }
      }
      //再转换为时间格式
      if (fieldName == "effectiveBeginDate") {
        this.quotationLineTableData.map(item => {
          item.effectiveBeginDate = this.$options.filters["dateFormatFilter"](item.effectiveBeginDate)
        });
      }

    }
  }
};
</script>
<style scoped lang="scss">
.topform {
  margin-top: 20px;
}

.handle-input {
  width: 99%;
}
</style>
<style  lang="scss">
.productQuotationApplicationAdd .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 200px;
}
</style>
